"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDPI = exports.getTileSizeSurface = exports.getDPIThreshold = void 0;
const tiles_1 = require("../consts/tiles");
const bleed_1 = require("../consts/bleed");
function getDPIThreshold(tileSize) {
    const tileSizeSurface = getTileSizeSurface(tileSize);
    if (tileSizeSurface >= getTileSizeSurface(tiles_1.TILE_SIZES.RECTANGLE_22X44)) {
        return 100;
    }
    if (tileSizeSurface >= getTileSizeSurface(tiles_1.TILE_SIZES.RECTANGLE_11X8)) {
        return 60;
    }
    return 0;
}
exports.getDPIThreshold = getDPIThreshold;
function getTileSizeSurface(tileSize) {
    if (!(tileSize in tiles_1.TILESIZES_TO_INCHES)) {
        return 0;
    }
    return (tiles_1.TILESIZES_TO_INCHES[tileSize].height *
        tiles_1.TILESIZES_TO_INCHES[tileSize].width);
}
exports.getTileSizeSurface = getTileSizeSurface;
// get DPI for current tile size unless another size given
function getDPI(tile, customSize) {
    if (!tile.tileSize && !tile.frameSize) {
        return;
    }
    const size = customSize || tile.tileSize || tile.frameSize;
    const { width, height } = tiles_1.TILESIZES_TO_INCHES[size];
    const { bleedWidth, bleedHeight } = (0, bleed_1.getBleed)({ materialType: tile.materialType, tileSize: size });
    const widthDPI = tile.width / (width + 2 * bleedWidth);
    const heightDPI = tile.height / (height + 2 * bleedHeight);
    return { widthDPI, heightDPI };
}
exports.getDPI = getDPI;
//# sourceMappingURL=sizes.js.map